import { render } from "./EditPaymentPage.vue?vue&type=template&id=29402ff6&ts=true"
import script from "./EditPaymentPage.vue?vue&type=script&lang=ts"
export * from "./EditPaymentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__